// extracted by mini-css-extract-plugin
export default {"newsfeedCard":"m5-z"};